// Terminologia fixa da Central de Alertas. As chaves internas são contrato
// com a correlação, o dataset e os filtros — nunca exibir a chave crua,
// sempre o rótulo correspondente.

export const SEVERIDADES = ["critico", "alto", "medio", "baixo", "informativo"];

export const LABEL_SEVERIDADE = {
	critico: "Crítico",
	alto: "Alto",
	medio: "Médio",
	baixo: "Baixo",
	informativo: "Informativo",
};

// Significado operacional de cada severidade. O nível entre parênteses é o
// nome do mesmo grau no Zabbix, que é a fonte real do campo (o mapeamento
// 0-5 -> chave vive em models/.../fontes/alertasZabbix.js no backend).
export const DESCRICAO_SEVERIDADE = {
	critico: "Queda total ou falha grave — ação imediata (Zabbix: Disaster).",
	alto: "Impacto relevante no serviço — priorizar (Zabbix: High).",
	medio: "Degradação parcial, sem interrupção total (Zabbix: Average).",
	baixo: "Limiar atingido, impacto pequeno (Zabbix: Warning).",
	informativo:
		"Registro sem impacto operacional (Zabbix: Information / Not classified).",
};

export const STATUS_INCIDENTE = [
	"aberto",
	"reconhecido",
	"em_andamento",
	"resolvido",
	"fechado",
];

export const LABEL_STATUS_INCIDENTE = {
	aberto: "Aberto",
	reconhecido: "Reconhecido",
	em_andamento: "Em andamento",
	resolvido: "Resolvido",
	fechado: "Fechado",
};

export const LABEL_STATUS_ATENDIMENTO = {
	aberto: "Aberto",
	em_andamento: "Em andamento",
	resolvido: "Resolvido",
};

export const LABEL_STATUS_OS = {
	pendente: "Pendente",
	em_execucao: "Em execução",
	concluida: "Concluída",
	cancelada: "Cancelada",
};

export const TIPOS_EVENTO = [
	"queda",
	"recuperacao",
	"atendimento_aberto",
	"atendimento_fechado",
	"os_criada",
	"os_concluida",
];

// Chave interna segue "queda" (contrato com dataset/backend); o rótulo
// exibido é "Incidente" — o evento cobre qualquer evento de problema.
export const LABEL_TIPO_EVENTO = {
	queda: "Incidente",
	recuperacao: "Recuperação",
	atendimento_aberto: "Atendimento aberto",
	atendimento_fechado: "Atendimento fechado",
	os_criada: "OS criada",
	os_concluida: "OS concluída",
};

export const CATEGORIAS_INTELIGENTES = [
	"zona_morta",
	"os_faltante",
	"falha_recorrente",
	"sla_em_risco",
];

export const LABEL_CATEGORIA_INTELIGENTE = {
	zona_morta: "Zona morta",
	os_faltante: "OS faltante",
	falha_recorrente: "Falha recorrente",
	sla_em_risco: "SLA em risco",
};

export const LABEL_CANAL_ATENDIMENTO = {
	telefone: "Telefone",
	email: "E-mail",
	chat: "Chat",
	automatico: "Automático",
};

export const PERIODOS = [
	{ valor: "24h", label: "Últimas 24h" },
	{ valor: "7d", label: "7 dias" },
	{ valor: "30d", label: "30 dias" },
	{ valor: "personalizado", label: "Personalizado" },
];

// Formata minutos como "12min 30s" (abaixo de 1h) ou "1h 24min".
export function formatarDuracaoMinutos(minutos) {
	if (minutos === null || minutos === undefined || Number.isNaN(minutos)) {
		return "—";
	}
	const totalSegundos = Math.round(minutos * 60);
	const horas = Math.floor(totalSegundos / 3600);
	const mins = Math.floor((totalSegundos % 3600) / 60);
	const segundos = totalSegundos % 60;
	if (horas > 0) return `${horas}h ${mins}min`;
	if (segundos > 0) return `${mins}min ${segundos}s`;
	return `${mins}min`;
}

// Duração compacta para leitura rápida: "45min", "3h 10min", "6d 17h".
export function formatarDuracaoCurta(minutos) {
	if (minutos === null || minutos === undefined || Number.isNaN(minutos)) {
		return "—";
	}
	const total = Math.max(1, Math.round(minutos));
	if (total < 60) return `${total}min`;
	if (total < 1440) {
		const resto = total % 60;
		return `${Math.floor(total / 60)}h${resto ? ` ${resto}min` : ""}`;
	}
	return `${Math.floor(total / 1440)}d ${Math.floor((total % 1440) / 60)}h`;
}

// Variação percentual entre períodos; null quando não comparável (base 0).
export function variacaoPercentual(atual, anterior) {
	if (
		anterior === null ||
		anterior === undefined ||
		anterior === 0 ||
		atual === null ||
		atual === undefined
	) {
		return null;
	}
	return ((atual - anterior) / Math.abs(anterior)) * 100;
}
